import React from 'react';
import { Flex, Text, Icon, Tooltip } from '@upsales/components';

type WidgetFieldSettingProps = {
	text: string;
	children: React.ReactNode;
	tooltip?: string;
};

const WidgetFieldSetting = ({ text, children, tooltip }: WidgetFieldSettingProps) => {
	return (
		<Flex direction="column" gap="u1">
			<Flex>
				<Text>{text}</Text>
				{tooltip ? (
					<Flex space="mlm">
						<Tooltip title={tooltip}>
							<Icon name="info" />
						</Tooltip>
					</Flex>
				) : null}
			</Flex>
			{children}
		</Flex>
	);
};

export default WidgetFieldSetting;
